import { useEffect } from 'react';
import { ProducerLocation } from '../../types';
import RestaurantConfigurationTable from '../components/RestaurantConfigurationTable';
import { socketEmit, SocketRPC } from '../lib/socket';
import useProducerLocations from '../store/producer-locations';
import useUser from '../store/user';

const RestaurantConfigurationPage = () => {
	const {user} = useUser();
	const { producerLocations, setProducerLocations } = useProducerLocations();

	useEffect(() => {
		let { producerKey = null, partnerKey } = user || {};
		if (partnerKey === 'wonder' && (!producerKey || producerKey === '')) {
			producerKey = 'wonder'
		}
		if (!producerKey) return;
		Promise.resolve()
			.then(() => {
				return socketEmit(SocketRPC.GetProducerLocations, { producerKey });
			})
			.then((res) => {
				if (!res.success) {
					throw new Error(res.error);
				}
				setProducerLocations(res.producerLocations);
			})
	}, []);

	const toggleFoodTruckOperation = async (producerLocation: ProducerLocation) => {
		return socketEmit(SocketRPC.ToggleFoodTruckOperation, { producerLocation, user }).then((res) => {
			if (!res.success) {
				return res;
			}
			const { isFoodTruckOperationPaused } = res;
			producerLocation.isFoodTruckOperationPaused = isFoodTruckOperationPaused;
			producerLocations && setProducerLocations(producerLocations);
			return res;
		});
	};

	const onAddressChanged = (producerLocation: ProducerLocation, newLocation: Object) => {
		producerLocation.location = newLocation;
		producerLocations && setProducerLocations(producerLocations);
	};

	const RestaurantConfigurationTableProps = {
		producerLocations: producerLocations || [],
		toggleFoodTruckOperation,
		onAddressChanged,
	};

	return RestaurantConfigurationTable(RestaurantConfigurationTableProps);
};

export default RestaurantConfigurationPage;
